import { jsx as _jsx } from "react/jsx-runtime";
const ListItem = ({ children, type, ...props }) => {
    return type === 'div' ? _jsx("div", { ...props, children: children }) : _jsx("li", { ...props, children: children });
};
export default ListItem;
